<!-- 侧边栏的组件 -->
<template>
  <div class="ceside">
    <div class="sliderbtn" @click="handleOpen()">
      <div :class="sliderbtn == true ? ' aa' : 'bb'" style="height: 70px">
        <div>
          <!-- <svg
            t="1705645689576"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4383"
            width="24"
            height="24"
          >
            <path
              d="M746.666667 377.6H277.333333c-23.466667 0-42.666667-19.2-42.666666-42.666667s19.2-42.666667 42.666666-42.666666h469.333334c23.466667 0 42.666667 19.2 42.666666 42.666666s-19.2 42.666667-42.666666 42.666667zM746.666667 554.666667H277.333333c-23.466667 0-42.666667-19.2-42.666666-42.666667s19.2-42.666667 42.666666-42.666667h469.333334c23.466667 0 42.666667 19.2 42.666666 42.666667s-19.2 42.666667-42.666666 42.666667zM746.666667 731.733333H277.333333c-23.466667 0-42.666667-19.2-42.666666-42.666666s19.2-42.666667 42.666666-42.666667h469.333334c23.466667 0 42.666667 19.2 42.666666 42.666667s-19.2 42.666667-42.666666 42.666666z"
              fill="#727477"
              p-id="4384"
            />
          </svg> -->
          <svg
            t="1705645321286"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4245"
            width="35"
            height="35"
          >
            <path
              d="M662.653 949.219c-3.779 0-7.668-0.02-11.695-0.06-58.766-0.581-105.413-2.615-138.755-6.048-33.859 3.433-80.633 5.467-139.131 6.048-89.695 0.897-115.737-8.836-130.513-19.479a37.012 37.012 0 0 1-11.537-13.612c-4.5-9.093-5.955-19.45-4.449-31.662 1.866-14.973 10.469-28.383 25.582-39.911 5.982-4.709 12.48-9.016 19.44-12.889-11.962-15.524-21.851-31.844-29.581-48.847a309.593 309.593 0 0 1-3.065-6.968c-15.077 17.037-28.899 26.224-43.755 29.552a36.98 36.98 0 0 1-8.087 0.895c-13.828 0-26.329-6.833-34.297-18.748-3.525-5.271-6.105-11.46-7.888-18.922-2.131-8.917-3.294-20.203-3.662-35.514-0.686-28.804 7.327-71.482 24.496-130.48 0.104-0.356 0.213-0.711 0.327-1.064 9.649-29.786 21.09-61.478 34.006-94.195 10.909-27.621 19.705-49.981 26.206-66.621v-20.599c-0.614-86.662 20.875-164.649 63.872-231.793 46.041-71.911 120.334-110.098 220.817-113.499a36.883 36.883 0 0 1 2.511 0c99.835 3.402 173.955 41.553 220.3 113.394 43.358 67.207 65.018 145.277 64.377 232.04-0.002 0.304-0.008 0.607-0.018 0.911l-0.642 20.05 26.367 66.871c13.305 32.94 24.664 64.529 33.762 93.893 0.052 0.168 0.103 0.337 0.153 0.506 17.149 58.28 25.319 100.7 24.978 129.685-0.181 15.441-1.204 26.819-3.218 35.803-1.686 7.516-4.186 13.758-7.644 19.084-7.804 12.021-20.719 19.198-34.548 19.198-2.721 0-5.433-0.3-8.087-0.895-14.887-3.335-28.824-12.594-44.156-29.8a311.701 311.701 0 0 1-2.981 6.931c-7.625 17.17-17.489 33.645-29.508 49.312a173.95 173.95 0 0 1 19.012 12.202c0.532 0.393 1.053 0.8 1.563 1.221 13.361 11.024 21.404 23.473 23.906 36.998 3.538 18.976-2.401 31.967-8.008 39.514a36.986 36.986 0 0 1-7.387 7.45c-15.89 12.014-42.634 20.047-119.063 20.048z m65.014-45.512z m-368.938-28.496c4.296 0.015 8.823 0 13.608-0.047 58.441-0.581 104.173-2.614 135.925-6.043a36.92 36.92 0 0 1 8.017 0.008c31.138 3.424 76.696 5.455 135.41 6.035 4.95 0.049 9.628 0.062 14.05 0.046a37.002 37.002 0 0 1-1.604-56.969c22.985-20.155 39.934-42.296 50.376-65.809 10.526-23.686 15.861-45.679 15.861-65.378 0-17.178 11.823-32.097 28.547-36.021 15.528-3.646 31.49 3.082 39.81 16.378-3.027-12.49-6.907-26.989-11.848-43.793-8.491-27.375-19.144-56.967-31.666-87.96l-0.115-0.288-29.233-74.139a36.978 36.978 0 0 1-2.56-14.756l0.872-27.233c0.455-71.92-17.229-136.154-52.565-190.927-32.698-50.685-84.839-76.699-159.383-79.507-75.076 2.809-127.339 28.789-159.743 79.399-35.164 54.913-52.724 119.337-52.192 191.486l0.001 0.272v27.693c0 4.595-0.856 9.15-2.524 13.432-6.713 17.231-16.421 41.929-28.854 73.405-12.272 31.086-23.127 61.127-32.266 89.296-4.82 16.592-8.611 30.913-11.573 43.265 8.38-13.061 24.197-19.634 39.584-16.023 16.724 3.924 28.547 18.843 28.547 36.021 0 19.579 5.441 41.476 16.171 65.085 10.746 23.64 27.89 45.88 50.953 66.101a37 37 0 0 1-1.606 56.971z m380.433-6.393z m109.735-134.485c0.001 0 0.001 0 0 0 0.001 0 0.001 0 0 0z"
              fill="#3fa2c7"
              p-id="4246"
            />
          </svg>
        </div>
        <div>
          <svg
            t="1710054076663"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4359"
            width="35"
            height="35"
          >
            <path
              d="M512 2.373117C230.785632 2.373117 2.966396 230.192352 2.966396 511.406721S230.785632 1020.440324 512 1020.440324s509.033604-227.819235 509.033604-509.033603S793.214368 2.373117 512 2.373117z m341.728853 619.383546L776.602549 698.882966a39.393743 39.393743 0 0 1-55.76825 0L512 490.048667 303.165701 698.882966a39.393743 39.393743 0 0 1-55.76825 0l-77.126304-77.126303a39.393743 39.393743 0 0 1 0-55.76825l234.938586-234.938587c1.186559-1.186559 1.186559-2.373117 2.373118-2.373117l77.126303-77.126303c3.559676-3.559676 8.30591-7.119351 13.052144-8.30591 14.238702-5.932793 32.03708-3.559676 42.716106 8.30591l77.126304 77.126303c1.186559 1.186559 3.559676 3.559676 4.746234 5.932793l232.565469 232.565469c14.238702 14.238702 14.238702 39.156431-1.186558 54.581692z"
              p-id="4360"
              fill="#3fa2c7"
            ></path>
          </svg>

          <!-- 
          <svg
            t="1705647551658"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="4521"
            width="24"
            height="24"
          >
            <path
              d="M512 162c-193.3 0-350 156.7-350 350s156.7 350 350 350 350-156.7 350-350-156.7-350-350-350z m0 643.3C350 805.3 218.7 674 218.7 512S350 218.7 512 218.7 805.3 350 805.3 512 674 805.3 512 805.3z"
              fill="#727477"
              p-id="4522"
            />
            <path
              d="M584.1 393.9L512 466l-72.1-72.1-46 46L466 512l-72.1 72.1 46 46L512 558l72.1 72.1 46-46L558 512l72.1-72.1z"
              fill="#727477"
              p-id="4523"
            />
          </svg> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["slider"],
  data() {
    //这里存放数据
    return {
      sliderbtn: false, //侧边栏的显示隐藏
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    slider: function (val) {
      this.sliderbtn = val;
    },
  },
  //方法集合
  methods: {
    
    //点击侧边栏的显示隐藏
    handleOpen() {
      this.$store.commit("playAudio");
      this.sliderbtn = !this.sliderbtn;
      this.$bus.$emit("sliderbtn", this.sliderbtn);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.aa {
  transition: all 0.4s linear;
  transform: translateY(-50%);
}
.bb {
  transition: all 0.4s linear;
  transform: translateY(0);
}
/* .ceside {
  position: relative;
  width: 35px;
  height: 35px;
  .sliderbtn {
    width: 100%;
    height: 100%;
    position: absolute;
    right: 30px;
    bottom: 100px;
  }
} */
.sliderbtn {
  width: 35px;
  height: 35px;
  padding-top: 7px 0 0 0;
  overflow: hidden;
  div {
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
  }
}
</style>